module.exports = __webpack_public_path__ + "static/access-control-b7aeda363b501edb16f6750b1231faa3.png";